


// import React, { useState, useEffect } from "react";
// import config from "./config"; // Adjust path as needed
// import "./Header.css";
// import { userSession } from "../observers/userObserver"; // Your custom session observer
// import NotificationDropdown from "./notificationDropdown";

// const Header = () => {

//   const [userEmail, setUserEmail] = useState("");

//   useEffect(()=>{
//     userSession.subscribeData(()=>{
//       setUserEmail(userSession.getUserEmail());
//     })
//   }, []);

//   useEffect(() => {
//     const fetchAndStoreUser = async () => {
//       // 🔍 Extract token from either search or hash (for HashRouter users)
//       const existingToken = userSession.getToken?.(); // Optional chaining in case getToken is undefined

//       if (!existingToken) {
//         const urlParams = new URLSearchParams(window.location.search);
//         const token = urlParams.get("token");
      
//         if (!token) {
//           console.error("❌ Token not found in URL.");
//           return;
//         }
      
//         userSession.setToken(token,payload.exp);
//         // continue logic like fetch user details here
//       }
//       try {
//         const response = await fetch(`${config["backend-url"]}/get_user_details`, {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${userSession.getToken()}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error("Failed to fetch user data");
//         }

//         const data = await response.json();
//         console.log("✅ API Response:", data);

//         userSession.setUser(data);

//       } catch (error) {
//         console.error("❌ Error fetching user data:", error);
//       }
//     };

//     fetchAndStoreUser();
//   }, []);

//   return (
//     <header className="header">
//       <div className="header-left">
//         <h2>AML Dealcheck</h2>
//       </div>
//       <div className="user-info">
//         <NotificationDropdown />
//         <span className="email">{userEmail || "No Email Provided"}</span>
//       </div>
//     </header>
//   );
// };

// export default Header;
import React, { useState, useEffect, useRef, useCallback } from "react";
import "./Header.css";
import NotificationDropdown from "./notificationDropdown";
import { useUserSession } from "../context/userSession";
import config from "./config";
import { userSession } from "../observers/userObserver";
import { useLocation } from "react-router-dom";
import { sharedData } from "../sharedData/sharedData";
const Header = () => {
   const location = useLocation();
  const { getUserEmail } = useUserSession();
  const email = getUserEmail() || "No Email Provided";
  const userInitial = email.charAt(0).toUpperCase();
  const [userRequests, setUserRequests] = useState([]);
const [logoUrl, setLogoUrl] = useState("");
  const [address, setAddress] = useState("");
  const [latestRequestId, setLatestRequestId] = useState("");
   const fetchUserRequests = async () => {
        try {
          const token = userSession.getToken();
          const response = await fetch(`${config["backend-url"]}/get_10user_request`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
  
          const data = await response.json();
  
          if (response.ok) {
            setLogoUrl(data.customer_logo);
            const addressFields = [
              data.customer_address.address1,
              data.customer_address.address2,
              data.customer_address.city,
              data.customer_address.state,
              data.customer_address.country,
              data.customer_address.postcode,
            ];
            setAddress(addressFields.filter(Boolean).join(", "));
  
            const requests = data.requests.map((request) => ({
              id: request.request_id,
              transaction: request.transaction_id || "N/A",
              Deligence_status: request.Deligence_status,
              client: request.company_name || "N/A",
              property: request.property_name || "N/A",
              propertyId: request.PropertyId,
              created_at: request.created_at || "N/A",
              modified_at: request.modified_at || "N/A",
              status: request.Request_Status,
              entityId: request.EntityId,
              MLNO_Approved_At: request.MLNO_Approved_At || "N/A",
            }));
            setUserRequests(requests);
          
          } else {
            console.error("Failed to fetch user requests:", data);
          }
        } catch (error) {
          console.error("Error fetching user requests:", error);
        }
      };
     useEffect(() => {
  fetchUserRequests();
}, []);
 const formPages = [
    "/transaction-detail",
    "/property-info",
    "/client-counter",
    "/corporate-structure",
    "/management-structure",
    "/RiskAsses",
    "/Edd",
    "/FinalReview",
    "/RiskAssesContinue",
  ];

  const isFormPage = formPages.some((path) => location.pathname.startsWith(path));
  const resolveCurrentRequestId = () =>
    sharedData.get?.("requestId") ||
    new URLSearchParams(location.search).get("requestId") ||
    localStorage.getItem("currentRequestId") ||
    "";

  // Update header id when route changes (or on mount)
  useEffect(() => {
    if (isFormPage) {
      setLatestRequestId(resolveCurrentRequestId());
    } else {
      setLatestRequestId("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search]);

  // Subscribe to sharedData requestId changes
  useEffect(() => {
    const unsubscribe = sharedData.subscribe("requestId", (newRequestId) => {
      if (isFormPage && newRequestId) {
        setLatestRequestId(newRequestId);
      }
    });

    return () => unsubscribe();
  }, [isFormPage]);
  return (
    <header className="header">
      <div className="header-left">
        <h2>AML Dealcheck</h2>
         {isFormPage && latestRequestId && (
          <span className="request-id"><strong>Request ID:</strong> {latestRequestId}</span>
        )}
      </div>
      <div className="header-right">
{logoUrl && (
        <div className="user-info">
          <div className="user-image">
            <img
              src={logoUrl}
              className="userimg"
              alt="Company Logo"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </div>
        </div>
        )}
      <div className="user-info">
        <NotificationDropdown />
        <div className="user-initial-circle">{userInitial}</div>
      </div>
      </div>
       
    </header>
  );
};

export default Header;

